/** URL slug for a city (prefer English name for stable routes). */
export function toCitySlug(citynameEn?: string, cityname?: string): string {
  const raw = (citynameEn || cityname || '').trim().toLowerCase();
  if (!raw) return 'city';
  return raw
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export function citySlugsMatch(
  slug: string,
  citynameEn?: string,
  cityname?: string
): boolean {
  return toCitySlug(citynameEn, cityname) === slug.toLowerCase();
}
